import {
  mdiArrowTopRightBottomLeft,
  mdiAttachment,
  mdiDeleteOutline,
  mdiTrayArrowDown
} from "@mdi/js";
import Icon from "@mdi/react";

import { useUserFeature } from "hooks/useUserFeature";
import { IAttachment } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  label: string;
  category?: string;
  data?: IAttachment | null;
  deleteFile?: (fileName: string) => void;
}

export default function HistoryPaymentItem({
  label,
  data,
  category,
  deleteFile
}: Readonly<IProps>) {
  const { isInvitedCarrier } = useUserFeature();
  const categoryList = category ? category.split(",") : [];

  return (
    <div className={styles.historyPaymentItemContainer}>
      <div className={styles.fileName}>
        <Icon path={mdiAttachment} className={styles.attachmentIcon} />
        <span className="underline break-all">{label}</span>
      </div>

      <div className={styles.toolGroup}>
        <ul className="flex flex-col items-end gap-1 text-sm text-text">
          {categoryList.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        {data?.preview_url && (
          <a href={data?.preview_url} target="_blank" rel="noopener noreferrer">
            <Icon path={mdiArrowTopRightBottomLeft} className="size-5" />
          </a>
        )}
        {data?.download_url && (
          <a href={data?.download_url} target="_blank" rel="noopener noreferrer">
            <Icon path={mdiTrayArrowDown} className="size-5" />
          </a>
        )}
        {!isInvitedCarrier && deleteFile && (
          <button onClick={() => deleteFile(label)}>
            <Icon path={mdiDeleteOutline} className="size-6" />
          </button>
        )}
      </div>
    </div>
  );
}
